import { request } from "../../utils/request";
import type { Team } from "./types";

/**
 * 获取部门列表
 * @param params 查询参数（可选）
 * @returns Promise<Team.DeptListResponse> 返回部门列表
 */
export const getDeptListApi = (params?: Team.GetDeptListParams) => {
  return request<Team.DeptListResponse>("/system/dept/list", {
    method: "GET",
    params: {
      pageNo: params?.pageNo || 1,
      pageSize: params?.pageSize || 20,
    },
  });
};

/**
 * 创建部门
 * @param data 部门数据
 * @returns Promise<Team.CreateDeptResponse> 返回创建结果
 */
export const createDeptApi = (data: Team.CreateDeptRequest) => {
  return request<Team.CreateDeptResponse>("/system/dept/create", {
    method: "POST",
    body: {
      name: data.name,
      parentId: data.parentId,
      sort: data.sort || 1024,
      status: data.status || 0,
    },
  });
};

/**
 * 删除部门
 * @param id 部门ID
 * @returns Promise<Team.DeleteDeptResponse> 返回删除结果
 */
export const deleteDeptApi = (id: number) => {
  return request<Team.DeleteDeptResponse>("/system/dept/delete", {
    method: "DELETE",
    params: {
      id,
    },
  });
};

/**
 * 更新部门（重命名等）
 * 需传入完整字段，缺失会被后端置为 null
 * @param data 部门更新数据
 * @returns Promise<Team.UpdateDeptResponse> 返回更新结果
 */
export const updateDeptApi = (data: Team.UpdateDeptRequest) => {
  return request<Team.UpdateDeptResponse>("/system/dept/update", {
    method: "PUT",
    body: {
      id: data.id,
      name: data.name,
      parentId: data.parentId,
      sort: data.sort,
      leaderUserId: data.leaderUserId,
      phone: data.phone,
      status: data.status,
    },
  });
};

/**
 * 获取部门精简信息列表
 * 后端接口：/system/dept/list-all-simple
 * 请求方法：GET
 * 响应数据：{ code: 0, data: DeptSimpleItem[], msg: "" }
 */
export const getDeptListSimpleApi = () => {
  return request<Team.DeptListSimpleResponse>("/system/dept/list-all-simple", {
    method: "GET",
  });
};

/**
 * 申请加入部门（团队）
 * 后端接口：/system/dept/apply-join
 * 请求参数：params: { deptId }
 * 响应数据：{ code: 0, data: false, msg: "" }
 */
export const applyJoinDeptApi = (deptId: number) => {
  return request<{
    code: number;
    data: boolean;
    msg: string;
  }>("/system/dept/apply-join", {
    method: "POST",
    params: {
      deptId,
    },
  });
};

/**
 * 获取部门信息
 * 后端接口：/system/dept/get
 * 请求参数：params: { id }
 * 响应数据：{ code: 0, data: DeptDetailItem, msg: "" }
 */
export const getDeptApi = (id: number) => {
  return request<Team.DeptDetailResponse>("/system/dept/get", {
    method: "GET",
    params: {
      id,
    },
  });
};

/**
 * 申请退出部门（团队）
 * 后端接口：/system/dept/apply-out
 * 请求方法：POST
 * 响应数据：{ code: 0, data: false, msg: "" }
 */
export const applyOutDeptApi = () => {
  return request<{
    code: number;
    data: boolean;
    msg: string;
  }>("/system/dept/apply-out", {
    method: "POST",
  });
};

